import { axiosConsumer } from '../consumer/axios-consumer';

const resource = '/api/area';

const apiFindAllAreas = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/list/all`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiFindByUserAreas = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/list/user`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiFindAreaById = async (id)=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/${id}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiCreateNewArea = async (req)=> new Promise((resolve, reject)=> axiosConsumer().put(`${resource}/create`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiUpdateExisistingArea = async (req)=> new Promise((resolve, reject)=> axiosConsumer().patch(`${resource}/edit`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiLogicDeleteAreaById = async (id)=> new Promise((resolve, reject)=> axiosConsumer().delete(`${resource}/${id}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const AreaRepository = {
  findAll: apiFindAllAreas,
  findByUser: apiFindByUserAreas,
  findById: apiFindAreaById,
  create: apiCreateNewArea,
  update: apiUpdateExisistingArea,
  deleteById: apiLogicDeleteAreaById
};